/**
 * @generated SignedSource<<9df132674524885f2a33f0bf274dab11>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: nx generate-api-types
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type StakingPageQuery$variables = Record<PropertyKey, never>;
export type StakingPageQuery$data = {
  readonly overview: {
    readonly items: ReadonlyArray<{
      readonly asset: {
        readonly id: string;
        readonly logoUrl: string | null | undefined;
        readonly name: string | null | undefined;
        readonly staking?: {
          readonly yearlyInterest: number | null | undefined;
        } | null | undefined;
      };
      readonly rewardsFiat: PrecisionFloat;
      readonly stakedFiat: PrecisionFloat;
    }> | null | undefined;
    readonly totalRewardsFiat: PrecisionFloat | null | undefined;
    readonly totalStakedFiat: PrecisionFloat | null | undefined;
  } | null | undefined;
};
export type StakingPageQuery = {
  response: StakingPageQuery$data;
  variables: StakingPageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalRewardsFiat",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalStakedFiat",
  "storageKey": null
},
v2 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "AssetStaking",
      "kind": "LinkedField",
      "name": "staking",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "yearlyInterest",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "CryptoAsset",
  "abstractKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "logoUrl",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rewardsFiat",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "stakedFiat",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "StakingPageQuery",
    "selections": [
      {
        "alias": "overview",
        "args": null,
        "concreteType": "StakingOverview",
        "kind": "LinkedField",
        "name": "stakingOverview",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "StakingOverviewItem",
            "kind": "LinkedField",
            "name": "items",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "asset",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/)
                ],
                "storageKey": null
              },
              (v6/*: any*/),
              (v7/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "StakingPageQuery",
    "selections": [
      {
        "alias": "overview",
        "args": null,
        "concreteType": "StakingOverview",
        "kind": "LinkedField",
        "name": "stakingOverview",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "StakingOverviewItem",
            "kind": "LinkedField",
            "name": "items",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "asset",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  },
                  (v2/*: any*/),
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/)
                ],
                "storageKey": null
              },
              (v6/*: any*/),
              (v7/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "579afe7fa4335ad421670ec3742a7bb6",
    "id": null,
    "metadata": {},
    "name": "StakingPageQuery",
    "operationKind": "query",
    "text": "query StakingPageQuery {\n  overview: stakingOverview {\n    totalRewardsFiat\n    totalStakedFiat\n    items {\n      asset {\n        __typename\n        ... on CryptoAsset {\n          staking {\n            yearlyInterest\n          }\n        }\n        id\n        name\n        logoUrl\n      }\n      rewardsFiat\n      stakedFiat\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "cda6528cc3c71ddfa6b594ed39a453d2";

export default node;
